// Injeta/atualiza um JSON-LD FAQPage no <head> a partir de uma lista de {q, a}.
// Faz o conteúdo da FAQ ser legível por máquina (Google AI Overview, rich results,
// e LLMs). IMPORTANTE: o schema deve refletir uma FAQ VISÍVEL na página.

const stripHtml = (s) =>
  String(s || "")
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, " ")
    .trim();

export function setFaqSchema(items) {
  if (!items || !items.length) return;
  const data = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: stripHtml(it.q),
      acceptedAnswer: { "@type": "Answer", text: stripHtml(it.a) },
    })),
  };
  let el = document.getElementById("faq-jsonld");
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "faq-jsonld";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function clearFaqSchema() {
  const el = document.getElementById("faq-jsonld");
  if (el) el.remove();
}
